export default __webpack_public_path__ + "static/media/6.5d3e07bd.png";